"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createShift = void 0;
const shift_create_1 = __importDefault(require("@app/request/shift-create"));
const util_1 = require("@app/util");
const promises_1 = require("@app/util/promises");
const moment_1 = __importDefault(require("moment"));
const store_1 = __importDefault(require("../../store"));
const is_loading_1 = __importDefault(require("../is-loading"));
const create_ac_1 = require("../util/create-ac");
const formHasPosition = (t) => (0, util_1.isDefined)(t.position);
const shiftHasPeriod = (t) => (0, util_1.isValue)(t.period);
exports.createShift = (0, create_ac_1.createAC)(async (dispatch, { form, copiesCount }) => {
    const { workspaceId, workspaceEvents } = store_1.default.getState();
    if (!(0, util_1.isValue)(workspaceId))
        return;
    await dispatch((0, is_loading_1.default)('create-shift'));
    if (!formHasPosition(form)) {
        await dispatch((0, is_loading_1.default)('create-shift', true));
        return;
    }
    const { localityId, ...rest } = form;
    const count = Math.abs(copiesCount ?? 1);
    const requests = Array.from({ length: count }).map(async () => await (0, shift_create_1.default)({
        workspace: workspaceId,
        data: { ...rest, locality: localityId },
    }));
    const settledRequests = await Promise.allSettled(requests);
    const results = settledRequests
        .filter(promises_1.isFulfilled)
        .map((res) => res.value)
        .filter(util_1.isDefined);
    await dispatch((0, is_loading_1.default)('create-shift', true));
    results.forEach((res) => {
        // if the shift is put into closed day, warn the user
        if (shiftHasPeriod(res)) {
            const closedEv = workspaceEvents.find((ev) => ev.type === 'closed' &&
                (0, moment_1.default)(res.period.start).isBefore(ev.period.end) &&
                (0, moment_1.default)(res.period.end).isAfter(ev.period.start));
            if (closedEv) {
                util_1.notification.warn({ code: 'addedShiftInClosedDay', message: '' });
            }
        }
    });
    return count === 1 ? results[0] : results;
});
